let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9K58V")).then(() => parcelRequire('194dz'));